export const SET_SEARCH_OPTIONS = "SET_SEARCH_OPTIONS";
export const RESET_SEARCH_OPTIONS = "RESET_SEARCH_OPTIONS";
export const SET_SEARCH_OPTIONS_REQUEST_STATUS = "SET_SEARCH_OPTIONS_REQUEST_STATUS";
